"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const UIRadio2_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIRadio2.vue"));
const OrderConfigInstance_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/OrderConfigInstance"));
const lucide_vue_next_1 = require("lucide-vue-next");
let OrderAreaSelect = class OrderAreaSelect extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.configInstance = null;
        this.config = null;
        // Flag for mounted and external changes
        this.hasBeenMounted = false;
        this.options = [
            {
                value: 'desc',
                label: 'Desc',
            },
            {
                value: 'asc',
                label: 'Asc',
            },
        ];
    }
    mounted() {
        this.onChangeValue();
        //this.$nextTick(() => this.hasBeenMounted = true);
    }
    onChangeValue() {
        if (!this.modelValue) {
            this.config = null;
            return;
        }
        this.hasBeenMounted = false;
        this.$nextTick(() => this.hasBeenMounted = true);
        this.config = this.modelValue.config;
        this.configInstance = this.modelValue;
    }
    onChangeConfig() {
        if (!this.hasBeenMounted) {
            console.warn("Change during mounting - ignore");
            return;
        }
        if (this.config) {
            this.configInstance = new OrderConfigInstance_1.default(this.config);
        }
        else {
            this.configInstance = null;
        }
        this.emitConfigInstance();
    }
    onChangeExtra() {
        var _a;
        if (((_a = this.configInstance) === null || _a === void 0 ? void 0 : _a.direction) === 'manual') {
            this.configInstance = null;
        }
        this.emitConfigInstance();
    }
    emitConfigInstance() {
        this.$emit('update:modelValue', this.configInstance);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], OrderAreaSelect.prototype, "modelValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], OrderAreaSelect.prototype, "configs", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('modelValue')
], OrderAreaSelect.prototype, "onChangeValue", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('config')
], OrderAreaSelect.prototype, "onChangeConfig", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('configInstance.direction')
], OrderAreaSelect.prototype, "onChangeExtra", null);
OrderAreaSelect = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            UIRadio2: UIRadio2_vue_1.default, User: lucide_vue_next_1.User
        }
    })
], OrderAreaSelect);
exports.default = OrderAreaSelect;
